import * as e from "react";
import { R as c } from "./index.H7ECscPa.js";
import { jsxs as i, Fragment as l, jsx as n } from "react/jsx-runtime";
var t = "AccessibleIcon", r = ({ children: o, label: a }) => {
  const s = e.Children.only(o);
  return /* @__PURE__ */ i(l, { children: [
    e.cloneElement(s, {
      // accessibility
      "aria-hidden": "true",
      focusable: "false"
      // See: https://allyjs.io/tutorials/focusing-in-svg.html#making-svg-elements-focusable
    }),
    /* @__PURE__ */ n(c, { children: a })
  ] });
};
r.displayName = t;
var f = r;
export {
  f as R
};
//# sourceMappingURL=index.DwnHX4bj.js.map
